var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c3bef7aedca6a74f985a7d8e16fe5a7ec48129b4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["supabase-app-staging@supabase"]={id:"c3bef7aedca6a74f985a7d8e16fe5a7ec48129b4"};
      